// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"162":"77223e45","164":"befc59ea","480":"fe4190a3","553":"54db6064","820":"c7febcf0","835":"4054f4ad","919":"af402ed3"}[chunkId] + ".css";
};